enum FrameSorting {
  POSITION = 0,
  MODEL_NAME_ASC = 1,
  MODEL_NAME_DESC = 2,
  PRICE_ASC = 3,
  PRICE_DESC = 4,
  DATE_CREATED_DESC = 5,
}

export default FrameSorting;
